import React, { Component } from 'react';
import Search from './Search.js';

class Header extends Component {
  render() {
    return (
      <header className="App-header">
        <Search
          onSearchTextChange={text => this.props.onSearchTextChange(text)}
          onSearch={text => this.props.onSearch(text)}
        />
      </header>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/Header.js